import { defaultMessageBackend } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--jira-empanada/jira-filter-refinement-filter-button';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren } from 'react';

import { FilterRefinementSpotlightTour } from './spotlight-tour';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ children, isEnabled }: PropsWithChildren<MessageTemplateContext>) => {
			if (!isEnabled) {
				return <>{children}</>;
			}

			return <FilterRefinementSpotlightTour>{children}</FilterRefinementSpotlightTour>;
		},
	},
});
